export interface FileExists {
    readonly type: "file-exists";
    readonly path: string;
}
